import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AsessmentConductType = {
	recordStageId?: string | undefined;
	recordQuestionId?: string | undefined;
};

const initialState: AsessmentConductType = {
	recordStageId: undefined,
	recordQuestionId: undefined
};

export const AsessmentConductSlice = createSlice({
	name: 'assessmentConduct',
	initialState,
	reducers: {
		updatePosition: (state, action: PayloadAction<AsessmentConductType>) => {
			state = Object.assign(state, action.payload);
		},
		updateStage: (state, action: PayloadAction<AsessmentConductType>) => {
			state = Object.assign(state, {
				...initialState,
				recordStage: action.payload.recordStageId
			});
		},
		updateQuestion: (state, action: PayloadAction<AsessmentConductType>) => {
			state = Object.assign(state, {
				...initialState,
				recordQuestion: action.payload.recordQuestionId
			});
		}
	}
});
